'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _util = require('../../../util');

var _util2 = _interopRequireDefault(_util);

var _console = require('../../../console');

var _button = require('../../../button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

/**
 * 操作按钮组
 */

var Console = function (_M$BaseComponent$Mixi) {
  _inherits(Console, _M$BaseComponent$Mixi);

  function Console() {
    _classCallCheck(this, Console);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Console).apply(this, arguments));
  }

  _createClass(Console, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var className = _props.className;
      var model = _props.model;
      var data = _props.data;
      var inRow = _props.inRow;
      var records = this.context.records;

      if (model == null) return null;
      var Console_ = this.props.Console || records.props.Console || records.Console || _console.Console;

      var buttons = [];
      (model.buttons || []).forEach(function (b) {
        var isRowBtn = inRow && b.hideIn != 'row';
        var newBtn = _extends({
          // 默认显示超小号button
          size: 'xsmall',
          // 如果是行操作，默认样式primary，没有边框
          style: isRowBtn ? 'primary' : 'default',
          shape: isRowBtn ? 'no-outline' : undefined
        }, b);
        if (newBtn.hideIn != (inRow ? 'row' : 'main')) {
          buttons.push(newBtn);
        }
      });
      var moreBtn = void 0;
      // 当button的数量超过6个时，合并显示
      if (!inRow && buttons.length > 6) {
        moreBtn = _react2.default.createElement(MoreButton, { className: className + '__more-btn', buttons: buttons.slice(5) });
        buttons = buttons.slice(0, 5);
      }
      model = _extends({}, model, { buttons: buttons });
      return _react2.default.createElement(
        'div',
        { className: this.classNames() },
        _react2.default.createElement(Console_, _extends({}, this.props, model, {
          data: data,
          className: className + '__btn-list',
          action: records._action })),
        moreBtn
      );
    }
  }]);

  return Console;
}(_util2.default.BaseComponent.Mixin(_util2.default.ContextMixin('records')));

var MoreButton = function (_M$BaseComponent) {
  _inherits(MoreButton, _M$BaseComponent);

  function MoreButton(props) {
    _classCallCheck(this, MoreButton);

    var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(MoreButton).call(this, props));

    Object.assign(_this2.state, {
      showList: false
    });
    return _this2;
  }

  _createClass(MoreButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      this.windowEventListener('click', function (e) {
        var showList = _this3.state.showList;
        var container = _this3.refs.container;

        if (showList && !(0, _reactDom.findDOMNode)(container).contains(e.target)) {
          _this3.toggleList(false);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var buttons = this.props.buttons;
      var showList = this.state.showList;

      return _react2.default.createElement(
        'div',
        { ref: 'container', className: this.classNames('more-button') },
        _react2.default.createElement(_button2.default, {
          className: 'more-button__btn',
          type: 'default',
          size: 'xsmall',
          label: '更多',
          icon: showList ? "angle-up" : "angle-down",
          onClick: this.toggleList.bind(this, !showList) }),
        showList && _react2.default.createElement(
          'ul',
          { className: 'more-button__btn-list' },
          buttons.map(function (item, i) {
            var action = item.action;

            var props = _objectWithoutProperties(item, ['action']);

            return _react2.default.createElement(
              'li',
              { key: i, className: 'more-button__btn-item' },
              _react2.default.createElement(_console.ConsoleButton, _extends({}, props, {
                size: 'small',
                shape: 'no-outline',
                onClick: _this4.action.bind(_this4, action) }))
            );
          })
        )
      );
    }
  }, {
    key: 'toggleList',
    value: function toggleList(show) {
      this.setState({ showList: show });
    }
  }, {
    key: 'action',
    value: function action(_action) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      _action && _action.apply(undefined, args);
      this.toggleList(false);
    }
  }]);

  return MoreButton;
}(_util2.default.BaseComponent);

exports.default = Console;